import { Box, Typography } from '@mui/material'
import { contactHero } from '../../data/contactContent'
import {
  MOBILE_MQ,
  mobileBodyTextSx,
  mobilePaddingX,
  mobileSectionPy,
  mobileSectionTitleSx,
} from '../../theme/mobileLayout'
import {
  contactMobileHeroSubtitleSx,
  contactMobileHeroTitleSx,
} from './contactMobileLayout'

export default function ContactHeroSection() {
  return (
    <Box
      component="section"
      sx={{
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: { xs: 6, md: 8 },
        textAlign: 'center',
        px: mobilePaddingX,
        [MOBILE_MQ]: { pb: '32px' },
      }}
    >
      <Typography
        component="h1"
        sx={{
          ...mobileSectionTitleSx,
          ...contactMobileHeroTitleSx,
          fontSize: { ...mobileSectionTitleSx.fontSize, lg: 80 },
          mb: '20px',
          maxWidth: 1200,
          mx: 'auto',
        }}
      >
        {contactHero.title}
      </Typography>
      <Typography
        sx={{
          ...mobileBodyTextSx,
          ...contactMobileHeroSubtitleSx,
          maxWidth: 1200,
          mx: 'auto',
        }}
      >
        {contactHero.subtitle}
      </Typography>
    </Box>
  )
}
